import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirEditGtapsAttributesService {

  constructor(private http: HttpClient) { }

  getEditAdjustAttrsData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let requestParams = Object.assign({}, globalService || {}, filterParams);
    requestParams = Object.assign({}, requestParams, params);
    requestParams.process_name = "GTAPS Get Edit Adjust Attributes Data";

    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + "/loadJsonObject?action_code=snqyk8"; // Action id 881

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveGTAPSAttributes(
    baseUrl: string,
    settings: any,
    editAttributesJson: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let requestParams = Object.assign({}, globalService || {}, filterParams);
    
    const jsonSettings = JSON.stringify(settings);
    const jsonObj = JSON.stringify(editAttributesJson);
    
    requestParams = Object.assign({}, requestParams, { jsonObj: jsonObj });
    requestParams = Object.assign({}, requestParams, { jsonSettings: jsonSettings });
    requestParams.process_name = "GTAPS_EDIT_ATTRS_SAVE";

    // Essential parameters with fallbacks
    requestParams.tax_year = filterParams.tax_year || requestParams.tax_year;
    requestParams.scenario = filterParams.scenario || requestParams.scenario;
    requestParams.jcd_key = filterParams.jcd_key || requestParams.jcd_key || 250; // AngularJS factory fallback
    requestParams.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || requestParams.scenarioCode || "RAF";
    requestParams.is_issue_key_enabled = "N";

    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + "/saveJsonObject?action_code=90pbor"; // Action id 1823

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}